/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { InterventionDto } from '../models/intervention-dto';
import { InterventionPhotoDto } from '../models/intervention-photo-dto';
import { LoadResult } from '../models/load-result';
import { TypeInterventionPhoto } from '../models/type-intervention-photo';


/**
 * Fonctions de gestion des interventions
 */
@Injectable({
  providedIn: 'root',
})
export class InterventionsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation interventionGetList
   */
  static readonly InterventionGetListPath = '/api/interventions/list';

  /**
   * Renvoie la liste des interventions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interventionGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<InterventionDto>>> {

    const rb = new RequestBuilder(this.rootUrl, InterventionsService.InterventionGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<InterventionDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des interventions.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interventionGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionGetList(params?: {
  }): Observable<Array<InterventionDto>> {

    return this.interventionGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<InterventionDto>>) => r.body as Array<InterventionDto>)
    );
  }

  /**
   * Path part for operation interventionLoadList
   */
  static readonly InterventionLoadListPath = '/api/interventions/load-list';

  /**
   * Renvoie la liste des interventions (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interventionLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  interventionLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, InterventionsService.InterventionLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des interventions (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interventionLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  interventionLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.interventionLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation interventionGet
   */
  static readonly InterventionGetPath = '/api/interventions/{id}';

  /**
   * Renvoie l'intervention spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interventionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionGet$Response(params: {

    /**
     * Identifiant de l&#x27;intervention spécifiée
     */
    id: number;
  }): Observable<StrictHttpResponse<InterventionDto>> {

    const rb = new RequestBuilder(this.rootUrl, InterventionsService.InterventionGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InterventionDto>;
      })
    );
  }

  /**
   * Renvoie l'intervention spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interventionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionGet(params: {

    /**
     * Identifiant de l&#x27;intervention spécifiée
     */
    id: number;
  }): Observable<InterventionDto> {

    return this.interventionGet$Response(params).pipe(
      map((r: StrictHttpResponse<InterventionDto>) => r.body as InterventionDto)
    );
  }

  /**
   * Path part for operation interventionAddDemandePhoto
   */
  static readonly InterventionAddDemandePhotoPath = '/api/interventions/{id}/photo-demande';

  /**
   * Ajoute une photo à l'intervention spécifiée (demande)
   * Taille maximum pour la photo : 20Mb.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interventionAddDemandePhoto()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionAddDemandePhoto$Response(params: {

    /**
     * Identifiant de l&#x27;intervention
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, InterventionsService.InterventionAddDemandePhotoPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Ajoute une photo à l'intervention spécifiée (demande)
   * Taille maximum pour la photo : 20Mb.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interventionAddDemandePhoto$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionAddDemandePhoto(params: {

    /**
     * Identifiant de l&#x27;intervention
     */
    id: number;
  }): Observable<number> {

    return this.interventionAddDemandePhoto$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation interventionAddInterventionPhoto
   */
  static readonly InterventionAddInterventionPhotoPath = '/api/interventions/{id}/photo-intervention';

  /**
   * Ajoute une photo à l'intervention spécifiée (intervention)
   * Taille maximum pour la photo : 20Mb.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interventionAddInterventionPhoto()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionAddInterventionPhoto$Response(params: {

    /**
     * Identifiant de l&#x27;intervention
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, InterventionsService.InterventionAddInterventionPhotoPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Ajoute une photo à l'intervention spécifiée (intervention)
   * Taille maximum pour la photo : 20Mb.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interventionAddInterventionPhoto$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionAddInterventionPhoto(params: {

    /**
     * Identifiant de l&#x27;intervention
     */
    id: number;
  }): Observable<number> {

    return this.interventionAddInterventionPhoto$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation interventionAddInterventionPhotoPda
   */
  static readonly InterventionAddInterventionPhotoPdaPath = '/api/interventions/{id}/photo-intervention/pda';

  /**
   * Ajoute une ou plusieurs photo PDA à l'intervention spécifiée (intervention).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interventionAddInterventionPhotoPda()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  interventionAddInterventionPhotoPda$Response(params: {

    /**
     * Identifiant de l&#x27;intervention
     */
    id: number;

    /**
     * Type de l&#x27;intervention
     */
    typeInterventionPhoto?: TypeInterventionPhoto;

    /**
     * Identifiants des photosPda
     */
    body: Array<number>
  }): Observable<StrictHttpResponse<InterventionDto>> {

    const rb = new RequestBuilder(this.rootUrl, InterventionsService.InterventionAddInterventionPhotoPdaPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('typeInterventionPhoto', params.typeInterventionPhoto, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InterventionDto>;
      })
    );
  }

  /**
   * Ajoute une ou plusieurs photo PDA à l'intervention spécifiée (intervention).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interventionAddInterventionPhotoPda$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  interventionAddInterventionPhotoPda(params: {

    /**
     * Identifiant de l&#x27;intervention
     */
    id: number;

    /**
     * Type de l&#x27;intervention
     */
    typeInterventionPhoto?: TypeInterventionPhoto;

    /**
     * Identifiants des photosPda
     */
    body: Array<number>
  }): Observable<InterventionDto> {

    return this.interventionAddInterventionPhotoPda$Response(params).pipe(
      map((r: StrictHttpResponse<InterventionDto>) => r.body as InterventionDto)
    );
  }

  /**
   * Path part for operation interventionGetPhotos
   */
  static readonly InterventionGetPhotosPath = '/api/interventions/{id}/photos';

  /**
   * Récupère la liste des photos liées à l'intervention spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interventionGetPhotos()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionGetPhotos$Response(params: {

    /**
     * Identifiant de l&#x27;intervention
     */
    id: number;
  }): Observable<StrictHttpResponse<Array<InterventionPhotoDto>>> {

    const rb = new RequestBuilder(this.rootUrl, InterventionsService.InterventionGetPhotosPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<InterventionPhotoDto>>;
      })
    );
  }

  /**
   * Récupère la liste des photos liées à l'intervention spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interventionGetPhotos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionGetPhotos(params: {

    /**
     * Identifiant de l&#x27;intervention
     */
    id: number;
  }): Observable<Array<InterventionPhotoDto>> {

    return this.interventionGetPhotos$Response(params).pipe(
      map((r: StrictHttpResponse<Array<InterventionPhotoDto>>) => r.body as Array<InterventionPhotoDto>)
    );
  }

  /**
   * Path part for operation interventionGetPhoto
   */
  static readonly InterventionGetPhotoPath = '/api/interventions/photos/{interventionPhotoId}';

  /**
   * Télécharge la photo d'une intervention spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interventionGetPhoto()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionGetPhoto$Response(params: {

    /**
     * Identifiant de la photo d&#x27;une intervention
     */
    interventionPhotoId: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, InterventionsService.InterventionGetPhotoPath, 'get');
    if (params) {
      rb.path('interventionPhotoId', params.interventionPhotoId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Télécharge la photo d'une intervention spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interventionGetPhoto$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionGetPhoto(params: {

    /**
     * Identifiant de la photo d&#x27;une intervention
     */
    interventionPhotoId: number;
  }): Observable<void> {

    return this.interventionGetPhoto$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation interventionDeletePhoto
   */
  static readonly InterventionDeletePhotoPath = '/api/interventions/photos/{interventionPhotoId}';

  /**
   * Supprime la photo d'une intervention spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interventionDeletePhoto()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionDeletePhoto$Response(params: {

    /**
     * Identifiant de la photo d&#x27;une intervention
     */
    interventionPhotoId: number;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, InterventionsService.InterventionDeletePhotoPath, 'delete');
    if (params) {
      rb.path('interventionPhotoId', params.interventionPhotoId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Supprime la photo d'une intervention spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interventionDeletePhoto$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  interventionDeletePhoto(params: {

    /**
     * Identifiant de la photo d&#x27;une intervention
     */
    interventionPhotoId: number;
  }): Observable<boolean> {

    return this.interventionDeletePhoto$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

}
